import { toggleClass, toggleAttribute } from '../helpers';

/**
 * Toggle additional locations dropdown
 * open and closed
 */
const init = () => {
	const additionalLocations = document.querySelector(
		'.listing-profile-sidebar__additional-locations',
	);
	const toggle = document.querySelector('.listing-profile-sidebar__additional-locations-toggle');

	// Bail if we don't have additional locations
	if (!toggle) {
		return;
	}

	/**
	 * Open additional locations container
	 */
	function openAdditionalLocations() {
		toggleClass(toggle, '-open');
		toggleClass(additionalLocations, '-open');
		toggleAttribute(additionalLocations, 'aria-hidden');
	}

	toggle.addEventListener('click', function () {
		openAdditionalLocations();
		this.blur();
	});
};

init();
